import classNames from "classnames";
import { PropsWithChildren, ReactNode } from "react";

import { useIsElementVisible } from "../../hooks/use_is_element_visible";
import css from "./render_if_visible.module.scss";

type RenderIfVisibleProps = PropsWithChildren<{
  placeholder?: ReactNode;
  scrollableContainerRef?: React.RefObject<HTMLElement | null>;
}>;

export const RenderIfVisible = ({ children, placeholder, scrollableContainerRef }: RenderIfVisibleProps) => {
  const { isVisible, elementRef } = useIsElementVisible({ scrollableContainerRef });

  return (
    <div ref={elementRef} className={css.fullSize}>
      {isVisible ? (
        <div className={classNames(css.fullSize, css.visibleContent)}>{children}</div>
      ) : (
        <div className={classNames(css.fullSize, css.hidden)}>{placeholder}</div>
      )}
    </div>
  );
};
